// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-5e07b196],\n.fade-leave-active[data-v-5e07b196] {\n    transition: opacity 0.25s ease-out;\n}\n.fade-enter[data-v-5e07b196],\n.fade-leave-to[data-v-5e07b196] {\n    opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
